export const branchClear = 'BRANCH_CLEAR';
export const branchFetch = 'BRANCH_FETCH';
export const branchSelected = 'BRANCH_SELECTED';
export const branchCreate = 'BRANCH_CREATE';

export default {
    clear: branchClear,
    fetch: branchFetch,
    selected: branchSelected,
    create: branchCreate
};
